<div class="body ui container" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div
      fxLayoutAlign="start center"
      fxLayout="row"
      fxLayoutGap="20px"
      (click)="goBack()"
      class="link"
    >
      <div>
        <img src="assets/icons/left-arrow-icon.svg" alt="" />
      </div>
      <div class="equipment-id">
        <!-- Title -->
        <span class="ui grey">Home</span>
        <h2
          class="ui primary header"
          style="display: flex; align-items: center"
        >
          eWallet
          <span
            class="ui green circular label"
            style="width: auto"
            *ngIf="status == 'ACTIVE'"
            >ACTIVE</span
          >
          <span
            class="ui red circular label"
            style="width: auto"
            *ngIf="status == 'INACTIVE'"
            >INACTIVE</span
          >
          <span
            class="ui yellow circular label"
            style="width: auto"
            *ngIf="status == 'PENDING'"
            >PENDING DEACTIVATION</span
          >
        </h2>
      </div>
    </div>

    <div
      class="ui basic primary dropdown"
      suiDropdown
      *ngIf="showDeactivateButton && status == 'ACTIVE'"
    >
      <esl-button
        buttonType="primary"
        buttonSize="small"
        buttonState="outline"
        buttonActionState="default"
        [hasLine]="true"
        [hasSuffixIcon]="true"
        [buttonMenu]="'dropdownMenu'"
        [hasDropdown]="true"
        [isClickable]="true"
      ></esl-button>
      <div class="left menu eWallet-dropdown" suiDropdownMenu>
        <div class="item deactivate-item" (click)="deactivateWallet()">
          Deactivate eWallet
        </div>
      </div>
    </div>
  </div>
  <div class="ui divider"></div>

  <div class="info" *ngIf="message">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 7.5V10.625M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 13.125H10.0063V13.1313H10V13.125Z"
        stroke="#00A0AC"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <p
      style="
        color: #505050;
        font-feature-settings: 'clig' off, 'liga' off;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      "
    >
      {{ transactionMessage || message }}
      <span *ngIf="!transactionMessage"
        >. Your RRR is {{ addHyphen(transactionRrr) }}, to review the status of
        your payment, please
      </span>
      <a class="referred-link" (click)="checkPaymentStatus()">click here</a>.
    </p>
  </div>

  <div *ngIf="success || error" tamsyMargin marginY="10px">
    <esl-message-toast [(message)]="error"></esl-message-toast>
    <esl-message-toast
      [(message)]="success"
      [messageType]="'success'"
    ></esl-message-toast>
  </div>

  <app-advanced-search-filter
    (onDisplayRows)="onDisplayRecords($event)"
    (onSearch)="searchRecords($event)"
    [hasAdvancedSearch]="true"
    [headers]="headers"
    [hasFilters]="true"
    (onSort)="sortRecords($event)"
    [searchFilters]="searchFilter"
    (advancedSearch)="advancedSearch($event)"
    (cancelAd)="cancelAd()"
  ></app-advanced-search-filter>

  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div
      fxLayout="row"
      tamsyMargin
      class="ui segment"
      marginB="3"
      fxLayoutGap="15px"
      fxLayoutAlign="center center"
      style="height: 36px"
      id="dark"
      appPadding
      paddingX="40px"
    >
      <div fxFlex="17">Currency</div>
      <div fxFlex="17">Balance</div>
      <div fxFlex="17">Book Balance</div>
      <div fxFlex="17">Status</div>
      <div fxFlex="18"></div>
      <div fxFlex="7"></div>
      <div fxFlex="7"></div>
    </div>

    <app-accounts-row
      [account]="account"
      *ngFor="let account of balances"
      (refreshEvent)="init()"
    ></app-accounts-row>

    <app-no-record-found
      *ngIf="balances && balances.length < 1"
    ></app-no-record-found>

    <!-- Pagination -->
    <div class="ui vertical basic segment">
      <div class="ui two column grid">
        <div class="column middle aligned">
          <div class="ui medium labeled button">
            <div class="records-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10 1C13.866 1 17 2.79086 17 5C17 7.20914 13.866 9 10 9C6.13401 9 3 7.20914 3 5C3 2.79086 6.13401 1 10 1ZM15.694 9.13079C16.1576 8.86588 16.6044 8.54736 17 8.17775V10C17 12.2091 13.866 14 10 14C6.13401 14 3 12.2091 3 10V8.17775C3.3956 8.54736 3.84244 8.86588 4.30604 9.13079C5.83803 10.0062 7.85433 10.5 10 10.5C12.1457 10.5 14.162 10.0062 15.694 9.13079ZM3 13.1777V15C3 17.2091 6.13401 19 10 19C13.866 19 17 17.2091 17 15V13.1777C16.6044 13.5474 16.1576 13.8659 15.694 14.1308C14.162 15.0062 12.1457 15.5 10 15.5C7.85433 15.5 5.83803 15.0062 4.30604 14.1308C3.84244 13.8659 3.3956 13.5474 3 13.1777Z"
                  fill="#86879D"
                />
              </svg>
            </div>
            <a class="ui basic label records-text"
              >{{ totalItems }} Record(s)</a
            >
          </div>
        </div>
        <div
          class="column right aligned pagination menu"
          style="margin-left: auto"
        >
          <sui-pagination
            class="small"
            [collectionSize]="totalItems"
            [pageSize]="rows"
            [maxSize]="maxSize"
            [hasEllipses]="false"
            [page]="currentPage"
            (pageChange)="nextPage($event)"
          >
          </sui-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
